import { PrismCard } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import SettingsMyotbCredentials from 'lumen/components/settings/myotb/credentials';
import SettingsMyotbOtbSelfServiceDataBar from 'lumen/components/settings/myotb/otb-self-service-data-bar';

<template>
  <PrismCard class="myotb-card">
    <:header as |Header|>
      <div class="grid gap-400">
        <SettingsMyotbOtbSelfServiceDataBar />
        <Header.title>{{t
            "settings.my_otb.data_validation.title"
          }}</Header.title>
      </div>
    </:header>

    <:content>
      <div class="myotb-card__content-container flex flex-col gap-400">
        <p class="paragraph-300--regular">
          {{t "settings.my_otb.data_validation.description"}}
        </p>

        <div class="flex flex-col gap-100">
          <span class="text-300--bold">
            {{t "settings.my_otb.validating.estimated_time"}}
          </span>
          <span class="text-300--regular">
            {{t "settings.my_otb.validating.estimated_time.hours"}}
          </span>
        </div>

        <SettingsMyotbCredentials />
      </div>
    </:content>
  </PrismCard>
</template>
